import type { StationeryDiscountInfo } from '../types';

type DiscountInfo =
  | ({
      preDiscountPriceInMinorUnits: number;
      totalPriceInMinorUnits: number;
      savingsInMinorUnits: number;
    } & { hasDiscount: true })
  | ({ totalPriceInMinorUnits: number } & { hasDiscount: false });

export const applyPercentDiscount = (discount: StationeryDiscountInfo & { type: 'percent' }, totalPriceInMinorUnits: number, deliveryPrice?: number): DiscountInfo => {
  const savings = Math.floor(totalPriceInMinorUnits * discount.percentage);
  const newTotal = totalPriceInMinorUnits - savings;

  return {
    preDiscountPriceInMinorUnits: totalPriceInMinorUnits + (deliveryPrice ?? 0),
    totalPriceInMinorUnits: newTotal,
    savingsInMinorUnits: savings,
    hasDiscount: true as const,
  };
};

export const applyFlatDiscount = (discount: StationeryDiscountInfo & { type: 'flatDiscountAmount' }, totalPriceInMinorUnits: number, deliveryPrice?: number): DiscountInfo => {
  const savings = Math.floor(discount.amount);
  const newTotal = totalPriceInMinorUnits - savings;

  return {
    preDiscountPriceInMinorUnits: totalPriceInMinorUnits + (deliveryPrice ?? 0),
    totalPriceInMinorUnits: newTotal,
    savingsInMinorUnits: savings,
    hasDiscount: true as const,
  };
};

export const calculateDiscount = (discount: StationeryDiscountInfo, totalPriceInMinorUnits: number, deliveryPrice?: number): DiscountInfo => {
  switch (discount.type) {
    case 'flatDiscountAmount': {
      return applyFlatDiscount(discount, totalPriceInMinorUnits, deliveryPrice);
    }
    case 'percent': {
      return applyPercentDiscount(discount, totalPriceInMinorUnits, deliveryPrice);
    }
  }
};
